import React, { useId } from 'react'
import { Col } from 'react-bootstrap'
import { TeamMember as TeamMemberType } from 'types'

interface PropsType {
    skeleton?: boolean,
    member?: TeamMemberType,
    iconsStyle?: string // '-solid' | '-light'
}

const TeamMember = (props: PropsType) => {

    const { member, skeleton, iconsStyle } = props;

    return (
        <Col xs={12} sm={6} lg={4} xl={3} id={"member-id" + useId()}
            className={"column-tm d-flex flex-column justify-content-center text-center my-4" + (skeleton ? " skeleton-column-tm" : "")}>
            <div className={"team-member" + (skeleton ? " skeleton-team-member" : "")}>
                { member?.image ?
                    <div className="img-hover-zoom rounded-circle">
                        <img src={member?.image} alt={member?.name} 
                             className={"object-fit-cover t-img" + (member?.filterStyle ? " filter-grey" : "") + (skeleton ? " skeleton-img" : "")} />
                    </div>
                    : <div className={"initials m-auto rounded-circle text-center d-flex justify-content-center align-items-center" + (skeleton ? " skeleton-initials" : "")}>{member?.name?.substring(0,1)}{member?.surname?.substring(0,1)}</div> }
                <h4 className={"mt-4 complate-name" + (skeleton ? " skeleton-name mb-2" : " mb-3")}>{member?.name} {member?.surname}</h4>
                <p className={"bold mb-3 position" + (skeleton ? " skeleton-position" : "")}>{member?.position}</p>
                <a href={"mailto:"+member?.email} className={"email d-block mb-2" + (skeleton ? " skeleton-email" : "")}>{member?.email}</a>
                <p className={"matricula mb-3" + (skeleton ? " skeleton-matricula" : "")}>{member?.matricula}</p>
                <a href={member?.bio} target="_blank" rel="noopener noreferrer" 
                    className={"bio d-block mb-2 mx-auto" + (skeleton ? " skeleton-bio" : "")}>
                    <i className={"me-2 icon-linkedin"+iconsStyle!}></i>
                    Ver bio
                </a>
            </div> 
        </Col>
    )
}

export default TeamMember